import { render, staticRenderFns } from "./HsmSyslogTab.vue?vue&type=template&id=2c473134&"
import script from "./HsmSyslogTab.vue?vue&type=script&lang=js&"
export * from "./HsmSyslogTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports